import {
  FaqCard,
  FastLoanProduct,
  Header,
  InvestmentProduct,
  MenuItem,
  TermLoanProduct,
  WhyCapital,
  ContactCapital,
} from 'components/CapitalRevamp';
import React, { Component } from 'react';
import withFeatureFlags from 'hocs/withFeatureFlags';
import styles from './DashboardRevamp.css';

class DashboardRevamp extends Component {
  render() {
    const { enableFastLoan } = this.props;
    return (
      <div>
        <Header />
        <MenuItem title="Produk" />
        <div className={styles['product-wrapper']}>
          <TermLoanProduct />
          <FastLoanProduct enable={enableFastLoan} />
          <InvestmentProduct />
          <FaqCard />
        </div>
        <div className={styles['info-wrapper']}>
          <div className={styles['why-capital']}>
            <WhyCapital />
          </div>
          <div className={styles['more-questions']}>
            <ContactCapital />
          </div>
        </div>
      </div>
    );
  }
}

const mapFlagsToProps = flags => ({
  enableFastLoan: flags.enableFastLoan,
});

export default withFeatureFlags(mapFlagsToProps)(DashboardRevamp);
